export const ajaxStart = (requestName) => ({ type: 'AJAX/START', requestName });
export const ajaxSuccess = (requestName, data) => ({ type: `AJAX/SUCCESS/${requestName}`, data });
export const ajaxFail = (requestName) => ({ type: `AJAX/FAILED/${requestName}` });
export const ajaxEnd = (requestName) => ({ type: `AJAX/END/${requestName}` });
